import { render, staticRenderFns } from "./WdmRuleA.vue?vue&type=template&id=bbf694cc"
import script from "./WdmRuleA.vue?vue&type=script&lang=js"
export * from "./WdmRuleA.vue?vue&type=script&lang=js"
import style0 from "./WdmRuleA.vue?vue&type=style&index=0&id=bbf694cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports